"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionLevels = /** @class */ (function () {
    function SubscriptionLevels(recover) {
        var _this = this;
        this.recover = recover;
        this.index = function () {
            return _this.recover.request("/subscription_levels", 'GET', null, null);
        };
        this.create = function (newSubscription) {
            return _this.recover.request("/subscription_levels", 'POST', newSubscription, null);
        };
        this.get = function (subscriptionId) {
            return _this.recover.request("/subscription_levels/" + subscriptionId, 'GET', null, null);
        };
        this.edit = function (subscriptionId, subscriptionChange) {
            return _this.recover.request("/subscription_levels/" + subscriptionId, 'PUT', subscriptionChange, null);
        };
    }
    return SubscriptionLevels;
}());
exports.default = SubscriptionLevels;
